import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, useTheme } from '@mui/material';
import { PhotoEvent } from 'common-models';
import { FC } from 'react';
import { Link } from 'react-router-dom';

type AdminEventLinkProps = {
    event: PhotoEvent,
}

const getVisibilityIcon = (event: PhotoEvent, theme: any): React.JSX.Element => {
    const iconSx = {
        fontSize: '1rem',
        mr: 0.5,
        color: event.isPublic ? theme.palette.success.main : theme.palette.error.main,
    };

    return event.isPublic
        ? <VisibilityIcon sx={iconSx} />
        : <VisibilityOffIcon sx={iconSx} />
}

const getShoppingCartIcon = (event: PhotoEvent, theme: any): React.JSX.Element => {
    const iconSx = {
        fontSize: '1rem',
        mr: 0.5,
        color: event.isFreeOfCharge ? theme.palette.warning.main : theme.palette.success.main,
    };

    return event.isFreeOfCharge
        ? <RemoveShoppingCartIcon sx={iconSx} />
        : <ShoppingCartIcon sx={iconSx} />
}

const getDateString = (event: PhotoEvent): string => {
    return `${event.eventStartTime.getFullYear()}-${(event.eventStartTime.getMonth() + 1).toString().padStart(2, '0')}-${event.eventStartTime.getDate().toString().padStart(2, '0')}`
}

const AdminEventLink: FC<AdminEventLinkProps> = ({ event }) => {
    const theme = useTheme();

    return (
        <Box
            component={Link}
            to={`/admin/events/${event.id}`}
            sx={{
                display: 'flex',
                alignItems: 'center',
                color: theme.palette.text.primary,
                textDecoration: 'none',
                maxWidth: '100%',
                overflow: 'hidden',
                '&:hover': {
                    textDecoration: 'underline',
                    color: theme.palette.primary.main,
                },
                '&:visited': {
                    color: theme.palette.text.primary,
                },
            }}
        >
            {getVisibilityIcon(event, theme)}
            {getShoppingCartIcon(event, theme)}
            <Box
                component="span"
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    minWidth: 0, // Allow flex item to shrink below its content size
                    flex: 1,
                }}
            >
                {event.title} ({getDateString(event)})
            </Box>
        </Box>
    )
}

export default AdminEventLink;
